import {
  InvestmentCategoryName,
  InvestmentGeographyName,
  InvestmentStageName
} from 'generated/graphql';
import _ from 'lodash';



export interface IAppState {
  investorSearchFilters: IInvestorSearchFilters
}

interface IInvestorSearchFilters {
  isFavorited: boolean | undefined;
  canLeadInvestments: boolean | undefined;
  verifiedByRidge: boolean | undefined;
  investmentCategories: InvestmentCategoryName[] | undefined;
  investmentAreas: string[] | undefined;
  investmentStages: InvestmentStageName[] | undefined;
  investmentGeographies: InvestmentGeographyName[] | undefined;
  city: string | undefined;
  usState: string | undefined;
  country: string | undefined;
}

let __appState: IAppState = __newAppState();



export function getAppState() {
  return _.cloneDeep(__appState);
}



function __newAppState(): IAppState {
  return {
    investorSearchFilters: {
      isFavorited: undefined,
      canLeadInvestments: undefined,
      verifiedByRidge: undefined,
      investmentCategories: undefined,
      investmentAreas: undefined,
      investmentStages: undefined,
      investmentGeographies: undefined,
      city: undefined,
      usState: undefined,
      country: undefined
    }
  };
}



export function reset() {
  __appState = __newAppState();
}



export function setInvestorSearchFilters(filters: IInvestorSearchFilters) {
  __appState.investorSearchFilters = filters;
}
